export var ActGraphsWording;
(function (ActGraphsWording) {
    ActGraphsWording["LoggedEmissions"] = "LoggedEmissions";
    ActGraphsWording["ForecastedEmissions"] = "ForecastedEmissions";
    ActGraphsWording["ForecastedEmissionsWithClimateActions"] = "ForecastedEmissionsWithClimateActions";
    ActGraphsWording["HistoricalEmissions"] = "HistoricalEmissions";
})(ActGraphsWording || (ActGraphsWording = {}));
export var ActGraphsType;
(function (ActGraphsType) {
    ActGraphsType["FORECAST"] = "forecast";
    ActGraphsType["ACTUALS"] = "actuals";
    ActGraphsType["TARGET"] = "target";
    ActGraphsType["ACTION"] = "action";
    ActGraphsType["REMAINING"] = "remaining";
    ActGraphsType["REDUCTION"] = "reduction";
    ActGraphsType["FORECAST_WITH_CLIMATE_ACTIONS"] = "forecastWithClimateActions";
})(ActGraphsType || (ActGraphsType = {}));
export var ActGraphsFormat;
(function (ActGraphsFormat) {
    ActGraphsFormat["RANGE"] = "RANGE";
    ActGraphsFormat["BAR"] = "BAR";
    ActGraphsFormat["LINE"] = "LINE";
    ActGraphsFormat["STEP_LINE"] = "STEP_LINE";
})(ActGraphsFormat || (ActGraphsFormat = {}));
export var WaterfallGraphBarType;
(function (WaterfallGraphBarType) {
    WaterfallGraphBarType["REFERENCE"] = "reference";
    WaterfallGraphBarType["GAP"] = "gap";
    WaterfallGraphBarType["FORECAST_BASE"] = "forecastBase";
    WaterfallGraphBarType["FORECAST_END"] = "forecastEnd";
    WaterfallGraphBarType["TARGET"] = "target";
    WaterfallGraphBarType["ACTION"] = "action";
})(WaterfallGraphBarType || (WaterfallGraphBarType = {}));
//# sourceMappingURL=ActGraphs.js.map